module.exports = {
      id: "gallery-whitebg-usage",
      viewBox: "0 0 44 44",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#gallery-whitebg",
      toString: function () {
        return this.url;
      }
    }